export default __webpack_public_path__ + "a8a3268a5e763c706bf48ed75d8ef5d1.png";